// import React, { useEffect, useState } from 'react'
// import {
//   Button, Card, Col, Drawer, Form, Input, notification,
//   Row, Select, Popconfirm, Tooltip
// } from 'antd'
// import _ from 'lodash'
// import moment from 'moment'
// import { useDispatch } from 'react-redux'
// import GetEachFormFields from '../../../../components/_utils/appFormUtils'
// import {
//   chooseEmailModalFxn, currencyList, formItemLayout
// } from '../../../../components/_utils/appUtils'
// // import { ApproveAbstract } from '../actions' // Ensure this is imported
//
// const { Option } = Select
//
// const ApprovalAbstractDrawer = props => {
//   let {
//     children,
//     form: { getFieldDecorator, setFieldsValue },
//     callback = null,
//     visible,
//     onClose,
//     edit,
//     abstract
//   } = props
//
//   const dispatch = useDispatch()
//   const authorData1 = { authors: [], noOfAuthors: null }
//   const [authorData, setAuthorData] = useState(authorData1)
//
//   let _updateState = data => {
//     setAuthorData(preState => ({ ...preState, ...data }))
//   }
//
//   const loopVal = noOfAuthors => {
//     let count = parseInt(noOfAuthors) || 0
//     let authors = Array.from({ length: count }, () => ({
//       name: '', email: '', orchId: ''
//     }))
//     setAuthorData({ authors, noOfAuthors: count })
//   }
//
//   const deleteAuthors = index => {
//     let cloneAuthor = _.clone(authorData.authors)
//     cloneAuthor.splice(index, 1)
//     setAuthorData({ authors: cloneAuthor, noOfAuthors: cloneAuthor.length })
//   }
//
//   const addNewAuthor = () => {
//     let authors = _.clone(authorData.authors)
//     authors.push({ name: '', email: '', orchId: '' })
//     setAuthorData({ authors, noOfAuthors: authors.length })
//   }
//
//   const authorsUpdate = (data, index) => {
//     let cloneAuth = _.clone(authorData.authors)
//     if (cloneAuth[index]) {
//       cloneAuth[index] = { ...cloneAuth[index], ...data }
//       setAuthorData({ ...authorData, authors: cloneAuth })
//     }
//   }
//
//   // let setFormData = () => {
//   //   if (edit) {
//   //     setAuthorData({
//   //       noOfAuthors: abstract.noOfAuthors,
//   //       authors: abstract.doiAuthors || []
//   //     })
//   //
//   //     props.form.setFieldsValue({
//   //       manuScriptTitle: abstract.manuScriptTitle,
//   //       approvalAmount: abstract.approvalAmount,
//   //       approvalInvoiceAddress: abstract.approvalInvoiceAddress, // Matches key in inputSchema
//   //       invoiceDate: abstract.invoiceDate ? moment(abstract.invoiceDate) : moment(),
//   //       currencyTypeOfApprovalAmount: abstract.currency, // Matches key in inputSchema
//   //       approvedAbstractDate: abstract.approvedAbstractDate ? moment(abstract.approvedAbstractDate) : moment(),
//   //       approvalSpecialNote: abstract.approvalSpecialNote
//   //     })
//   //   } else {
//   //     props.form.setFieldsValue({
//   //       manuScriptTitle: abstract.titleOfAbstract,
//   //       invoiceDate: moment(),
//   //       approvedAbstractDate: moment()
//   //     })
//   //   }
//   // }
//   let setFormData = () => {
//     if (edit) {
//       setAuthorData({
//         noOfAuthors: abstract.noOfAuthors,
//         authors: abstract.doiAuthors || []
//       })
//
//       props.form.setFieldsValue({
//         manuScriptTitle: abstract.manuScriptTitle,
//         approvalAmount: abstract.approvalAmount,
//         approvalInvoiceAddress: abstract.approvalInvoiceAddress,
//         invoiceDate: abstract.invoiceDate ? moment(abstract.invoiceDate) : moment(),
//         currencyTypeOfApprovalAmount: abstract.currency,
//         approvedAbstractDate: abstract.approvedAbstractDate ? moment(abstract.approvedAbstractDate) : moment(),
//         approvalSpecialNote: abstract.approvalSpecialNote
//       })
//     } else {
//       // 🌟 NEW: Extract authors from the original abstract submission
//       let initialAuthors = []
//
//       // 1. Push the main corresponding author
//       if (abstract.authorName) {
//         initialAuthors.push({
//           name: abstract.authorName,
//           email: abstract.email || '',
//           orchId: abstract.orcidId || ''
//         })
//       }
//
//       // 2. Push any co-authors
//       if (abstract.coAuthors && abstract.coAuthors.length > 0) {
//         abstract.coAuthors.forEach(co => {
//           initialAuthors.push({
//             name: co.name || '',
//             email: co.email || '',
//             orchId: co.orcidId || co.orchId || ''
//           })
//         })
//       }
//       setAuthorData({
//         noOfAuthors: initialAuthors.length,
//         authors: initialAuthors
//       })
//
//       props.form.setFieldsValue({
//         manuScriptTitle: abstract.titleOfAbstract,
//         invoiceDate: moment(),
//         approvedAbstractDate: moment()
//       })
//     }
//   }
//   useEffect(() => {
//     if (visible) {
//       setTimeout(setFormData, 500)
//     }
//   }, [visible])
//
//   const inputSchema = {
//     fields: [
//       { label: 'Abstract Title', key: 'manuScriptTitle', type: 'editor', required: true, span: 24 },
//       { label: 'Approved Date', key: 'approvedAbstractDate', required: true, type: 'date' },
//       { label: 'Invoice Date', key: 'invoiceDate', required: true, type: 'date' },
//       // { label: 'Currency', key: 'currencyTypeOfApprovalAmount', required: true, type: 'select', options: currencyList },
//       {
//         label: 'Currency',
//         key: 'currencyTypeOfApprovalAmount',
//         required: true,
//         type: 'select',
//         options: currencyList,
//         onChange: (value) => {
//           setFieldsValue({ currencyTypeOfApprovalAmount: value });
//         }
//       },
//       { label: 'Approval Amount', key: 'approvalAmount', required: true, type: 'number' },
//       {
//         label: 'Invoice Name',
//         key: 'approvalInvoiceName'
//       },
//       {
//         label: 'Address',
//         key: 'approvalInvoiceAddress',
//         type: 'textArea',
//         required: true,
//         span: 16
//       },
//       { label: 'Special Note', key: 'approvalSpecialNote', span: 24, type: 'textArea' }
//     ]
//   }
//
//   const handleSubmit = e => {
//     e.preventDefault()
//     props.form.validateFieldsAndScroll(async (err, valData) => {
//       if (!err) {
//         chooseEmailModalFxn({
//           title: 'Approve Abstract',
//           callback: async email => {
//             valData.fromEmail = email
//             valData.abstractId = abstract._id
//             valData.template = 'approvedAbstract'
//             if (!edit) {
//               valData.abstractStatus = 'Approved Abstract'
//               valData.approvedDate = new Date()
//             }
//             valData.doiAuthors = authorData.authors
//             valData.noOfAuthors = authorData.noOfAuthors
//
//             // let { success } = await dispatch(ApproveAbstract(valData))
//             // if (success) {
//             //   if (callback) callback()
//             //   onClose()
//             //   dispatch({ type: 'START_LOAD_ABSTRACT' })
//             // }
//           }
//         })
//       }
//     })
//   }
//
//   return (
//     <Drawer
//       title={`Approve Abstract | ID: ${abstract.abstractNo || ''}`}
//       width={'70%'}
//       visible={visible}
//       placement='right'
//       onClose={onClose}>
//       <Card>
//         <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
//           <Row gutter={16}>
//             {inputSchema.fields.map((item, key) => (
//               <Col span={item.span || 8} key={key}>
//                 <GetEachFormFields getFieldDecorator={getFieldDecorator} item={item} formItemLayout={formItemLayout} />
//               </Col>
//             ))}
//             <Col span={24}>
//               <Card title='Authors'>
//                 {authorData.authors && authorData.authors.length > 0 ? (
//                   <Row gutter={16}>
//                     {authorData.authors.map((item, key) => (
//                       <Col span={24} key={key} style={{ marginBottom: '10px' }}>
//                         <Row gutter={16} type="flex" align="middle">
//                           <Col span={6}>
//                             <Form.Item label='Name' style={{ marginBottom: 0 }}>
//                               <Input value={item.name} disabled />
//                             </Form.Item>
//                           </Col>
//                           <Col span={6}>
//                             <Form.Item label='Email' style={{ marginBottom: 0 }}>
//                               <Input value={item.email} disabled />
//                             </Form.Item>
//                           </Col>
//                           <Col span={6}>
//                             <Form.Item label='Orch Id' style={{ marginBottom: 0 }}>
//                               <Input value={item.orchId} disabled />
//                             </Form.Item>
//                           </Col>
//                           {/* The 4th column can be used for extra info or left empty for symmetry */}
//                           <Col span={6} style={{ textAlign: 'center' }}>
//                             <span className="ant-tag">Author {key + 1}</span>
//                           </Col>
//                         </Row>
//                       </Col>
//                     ))}
//                   </Row>
//                 ) : (
//                   <p>No authors available for this abstract.</p>
//                 )}
//               </Card>
//             </Col>
//             <Col span={24}>
//               <Form.Item style={{ marginTop: 40 }}>
//                 <Button type='primary' htmlType='submit'>Submit</Button>
//               </Form.Item>
//             </Col>
//           </Row>
//         </Form>
//       </Card>
//     </Drawer>
//   )
// }
//
// export default Form.create()(ApprovalAbstractDrawer)

import React, { useEffect, useState } from 'react'
import {
  Button, Card, Col, Drawer, Form, Input, Row, Select, Table
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import {
  chooseEmailModalFxn, currencyList, formItemLayout
} from '../../../../components/_utils/appUtils'

const { Option } = Select

const ApprovalAbstractDrawer = props => {
  let {
    form: { getFieldDecorator, setFieldsValue },
    visible,
    onClose,
    edit,
    abstract
  } = props

  const dispatch = useDispatch()

  // Clean states for editable display
  const [affiliationData, setAffiliationData] = useState([])
  const [authorData, setAuthorData] = useState({ authors: [], superScriptList: [] })

  // 🌟 Handle dynamic updates to the author grid rows on typing
  const authorsUpdate = (data, index) => {
    let cloneAuth = _.clone(authorData.authors)
    if (cloneAuth[index]) {
      cloneAuth[index] = { ...cloneAuth[index], ...data }
      setAuthorData({ ...authorData, authors: cloneAuth })
    }
  }

  // --- POPULATE DATA ON OPEN ---
  const setFormData = () => {
    let finalAuthors = []
    let finalAffiliations = []
    let superScriptListInit = ['*']

    if (edit && abstract.doiAuthors && abstract.doiAuthors.length > 0) {
      finalAuthors = abstract.doiAuthors
      if (abstract.affiliationData && abstract.affiliationData.length > 0) {
        finalAffiliations = abstract.affiliationData
      }
      for (let i = 0; i < finalAffiliations.length; i++) {
        superScriptListInit.push(i + 1)
      }
    } else {
      // Fallback for new approvals / missing historical structures
      if (abstract.authorName) {
        finalAuthors.push({
          name: abstract.authorName,
          email: abstract.email || '',
          script: [1],
          orchId: abstract.orcidId || abstract.orchId || ''
        })
        superScriptListInit.push(1)
      }
      if (abstract.institution) {
        finalAffiliations.push({ affiliate: abstract.institution })
      }

      const rawCoAuthors = abstract.coAuthors || abstract.coAuthor || []
      if (rawCoAuthors && rawCoAuthors.length > 0) {
        rawCoAuthors.forEach((item, key) => {
          finalAuthors.push({
            name: item.name || '',
            email: item.email || '',
            script: [key + 2],
            orchId: item.orcidId || item.orchId || ''
          })

          const affText = item.affiliation || item.instituteAffiliated || item.institution || ''
          if (affText) {
            finalAffiliations.push({ affiliate: affText })
          }
          superScriptListInit.push(key + 2)
        })
      }
    }

    setAuthorData({
      authors: finalAuthors,
      superScriptList: superScriptListInit
    })
    setAffiliationData(finalAffiliations)

    if (edit) {
      props.form.setFieldsValue({
        manuScriptTitle: abstract.manuScriptTitle,
        approvalAmount: abstract.approvalAmount,
        approvalInvoiceAddress: abstract.approvalInvoiceAddress,
        invoiceDate: abstract.invoiceDate ? moment(abstract.invoiceDate) : moment(),
        currencyTypeOfApprovalAmount: abstract.currency,
        approvedAbstractDate: abstract.approvedAbstractDate ? moment(abstract.approvedAbstractDate) : moment(),
        approvalSpecialNote: abstract.approvalSpecialNote
      })
    } else {
      props.form.setFieldsValue({
        manuScriptTitle: abstract.titleOfAbstract,
        approvalAmount: abstract.publicationCharges,
        approvalInvoiceName: abstract.authorName,
        approvalInvoiceAddress: abstract.institution || '',
        invoiceDate: moment(),
        currencyTypeOfApprovalAmount: abstract.currency,
        approvedAbstractDate: moment()
      })
    }
  }

  useEffect(() => {
    if (visible) {
      setTimeout(() => setFormData(), 500)
    }
  }, [visible])

  // --- AFFILIATION TABLE COLUMNS ---
  const columns = [
    { title: 'Serial no', key: 'serial', render: (text, record, index) => <div>{index + 1}</div>, width: 120 },
    { title: 'Affiliate', dataIndex: 'affiliate', key: 'affiliate' }
  ]

  const inputSchema = {
    fields: [
      { label: 'Abstract Title', key: 'manuScriptTitle', type: 'editor', required: true, span: 24 },
      { label: 'Approved Date', key: 'approvedAbstractDate', required: true, type: 'date' },
      { label: 'Invoice Date', key: 'invoiceDate', required: true, type: 'date' },
      {
        label: 'Currency', key: 'currencyTypeOfApprovalAmount', required: true, type: 'select', options: currencyList,
        onChange: (value) => setFieldsValue({ currencyTypeOfApprovalAmount: value })
      },
      { label: 'Approval Amount', key: 'approvalAmount', required: true, type: 'number' },
      { label: 'Invoice Name', key: 'approvalInvoiceName' },
      { label: 'Address', key: 'approvalInvoiceAddress', type: 'textArea', required: true, span: 16 },
      { label: 'Special Note', key: 'approvalSpecialNote', span: 24, type: 'textArea' }
    ]
  }

  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        chooseEmailModalFxn({
          title: 'Approve Abstract',
          callback: async email => {
            valData.fromEmail = email
            valData.abstractId = abstract._id
            valData.template = 'approvedAbstract'
            if (!edit) {
              valData.abstractStatus = 'Approved Abstract'
              valData.approvedDate = new Date()
            }
            valData.affiliationData = affiliationData
            valData.doiAuthors = authorData.authors // Saves updated, edited author row configurations
            valData.noOfAuthors = authorData.authors.length

            // System can safely fire ApproveAbstract action here when uncommented
          }
        })
      }
    })
  }

  return (
    <Drawer
      title={`Approve Abstract | ID: ${abstract.abstractNo || abstract.abstractId || ''}`}
      width={'70%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span || 8} key={key}>
                <GetEachFormFields getFieldDecorator={getFieldDecorator} item={item} formItemLayout={formItemLayout} />
              </Col>
            ))}

            <Col span={24}>
              {/* 1. Affiliation View-Only Grid (No Add/Edit buttons) */}
              <Card title={'Affiliation'}>
                <Table size='small' columns={columns} className={'figureTable'} dataSource={affiliationData} pagination={false} rowKey={(r, i) => i} />
              </Card>

              {/* 2. 4-Column Editable Author Grid (No Row modifications buttons) */}
              <Card title='Authors' style={{ marginTop: 20 }}>
                {authorData.authors && authorData.authors.length ? (
                  <>
                    {authorData.authors.map((item, key) => (
                      <Row key={key} gutter={16}>
                        <Col span={6}>
                          <Form.Item label='Name'>
                            <Input
                              placeholder='Enter Name'
                              value={item.name}
                              onChange={e => authorsUpdate({ name: e.target.value }, key)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item label='Email Address'>
                            <Input
                              placeholder='Enter Email Address'
                              type={'email'}
                              value={item.email}
                              onChange={e => authorsUpdate({ email: e.target.value }, key)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item label='Super Script'>
                            <Select
                              mode='multiple'
                              value={item.script}
                              placeholder='Select Script'
                              onChange={e => authorsUpdate({ script: e }, key)}
                            >
                              {authorData.superScriptList && authorData.superScriptList.map((s, i) => (
                                <Option key={i} value={s}>{s}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item label='Orch Id'>
                            <Input
                              placeholder='Enter Orch Id'
                              value={item.orchId}
                              onChange={e => authorsUpdate({ orchId: e.target.value }, key)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    ))}
                  </>
                ) : (
                  <div style={{ textTransform: 'none', color: '#999' }}>No authors linked to this abstract.</div>
                )}
              </Card>
            </Col>

            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>Submit</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(ApprovalAbstractDrawer)
